// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"8fd1a5c8","441":"8fd1a5c8"}[chunkId] + ".chunk.css";
};